import styled from 'styled-components';
import { TooltipColorDefinition } from './Tooltip.props';

export const TooltipRoot = styled.div<{
    $colorDefinition: TooltipColorDefinition;
}>`
  font-family: ${props => props.theme.font};
  border-radius: 5px;
  display: flex;
  padding: 4px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-shadow: 2px 1px 12px 0 rgba(32, 56, 87, 0.18);
  color: ${props => props.$colorDefinition.color};
  background: ${props => props.$colorDefinition.background};
  border: 1px solid ${props => props.$colorDefinition.border};
  z-index: 9999;

  &[data-popper-interactive='false'] {
    pointer-events: none;
  }

  .tooltip-arrow {
    height: 1rem;
    position: absolute;
    width: 1rem;
    pointer-events: none;
  }

  .tooltip-arrow::before {
    border-style: solid;
    content: '';
    display: block;
    height: 0;
    margin: auto;
    width: 0;
  }

  &[data-popper-placement*='bottom'] .tooltip-arrow {
    left: 0;
    margin-top: -0.7rem;
    top: 0;
  }

  &[data-popper-placement*='bottom'] .tooltip-arrow::before {
    border-color: transparent transparent ${props => props.$colorDefinition.background} transparent;
    border-width: 0 0.5rem 0.4rem 0.5rem;
    position: absolute;
    top: -1px;
  }

  &[data-popper-placement*='top'] .tooltip-arrow {
    bottom: 0;
    left: 0;
    margin-bottom: -0.7rem;
  }

  &[data-popper-placement*='top'] .tooltip-arrow::before {
    border-color: ${props => props.$colorDefinition.background} transparent transparent transparent;
    border-width: 0.4rem 0.5rem 0 0.5rem;
    position: absolute;
    top: 1px;
  }

  &[data-popper-placement*='right'] .tooltip-arrow {
    left: 0;
    margin-left: -0.8rem;
  }

  &[data-popper-placement*='right'] .tooltip-arrow::before {
    border-color: transparent ${props => props.$colorDefinition.background} transparent transparent;
    border-width: 0.5rem 0.4rem 0.5rem 0;
  }

  &[data-popper-placement*='left'] .tooltip-arrow {
    margin-right: -0.8rem;
    right: 0;
  }

  &[data-popper-placement*='left'] .tooltip-arrow::before {
    border-color: transparent transparent transparent ${props => props.$colorDefinition.background};
    border-width: 0.5rem 0 0.5rem 0.4rem;
  }
`;
